import { render, staticRenderFns } from "./ProductTagList.vue?vue&type=template&id=bd19096c&scoped=true"
import script from "./ProductTagList.vue?vue&type=script&lang=js"
export * from "./ProductTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd19096c",
  null
  
)

export default component.exports